import { round2 } from '../common/sick';
import { getSocialInsuranceDailyBase } from '../LegalParameters/SocialInsuranceDailyBase';
import { SOCIAL_INSURANCE_REDUCTION_MULTIPLIERS_CHILDCARE, SOCIAL_INSURANCE_CHILDCARE_TOTAL_AMOUNT } from '../LegalParameters/Constants';

export function getDailyIncome(income) {
	return round2((income * 12) / 365);
}

export function getMaxSubsidy(base, children) {
	// Když mám jedno dítě, je to podle redukovaného DVZ a minimálně 7600
	// Když mám víc děti, je to podle 1.5 násobku redukovaného DVZ a minimálně 7600
	let usedBase = Math.max(7600, base);
	if (children > 1) {
		usedBase *= 1.5;
	}

	return Math.ceil(usedBase);
}

export function getDivision(number1, number2) {
	return Math.ceil(number1 / number2);
}

export default function({ year, income, children, length, subsidy }) {
	const dailyIncome = getDailyIncome(income);
	const reducedBase = getSocialInsuranceDailyBase({
		income: dailyIncome,
		year,
		multipliers: SOCIAL_INSURANCE_REDUCTION_MULTIPLIERS_CHILDCARE[year],
	});
	const base = reducedBase * 0.7 * 30;

	const totalSubsidy = children === 1 ? SOCIAL_INSURANCE_CHILDCARE_TOTAL_AMOUNT[year][0] : SOCIAL_INSURANCE_CHILDCARE_TOTAL_AMOUNT[year][1];

	const maxSubsidy = getMaxSubsidy(base, children);
	const minLength = getDivision(totalSubsidy, maxSubsidy);

	let calculatedSubsidy = Math.min(getDivision(totalSubsidy, length), maxSubsidy);
	let calculatedLength = Math.max(getDivision(totalSubsidy, subsidy), minLength);
	let desiredSubsidy = Math.min(subsidy, maxSubsidy);
	let desiredLength = Math.max(length, minLength);

	if (calculatedLength > 43) {
		calculatedLength = 43;
		desiredSubsidy = getDivision(totalSubsidy, calculatedLength);
	}

	return {
		maxSubsidy,
		minLength,
		desiredSubsidy,
		calculatedLength,
		desiredLength,
		calculatedSubsidy,
	};
}
